import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import * as fa from '@fortawesome/free-solid-svg-icons';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { User } from 'src/app/classes/user';

import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})

export class PasswordComponent implements OnInit {
  @ViewChild('password') password!: ElementRef
  
  user!: User

  passwordForm = new FormGroup({
    password: new FormControl(''),
    email: new FormControl(false)
  })

  fa = fa

  constructor(private userService: UserService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    this.passwordForm.get('password')?.setValue(((o=12,n="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$")=>Array.from(crypto.getRandomValues(new Uint32Array(o))).map(o=>n[o%n.length]).join(""))())
  }

  setPassword() {
    this.userService.setPassword(this.user.id, this.passwordForm.value).subscribe(data => {
      this.activeModal.close()
    })
  }

  togglePassword() {
    this.password.nativeElement.type = this.password.nativeElement.type == 'password' ? 'text' : 'password'
  }
}
